import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const chatImages = ['https://cdn.magicpatterns.com/uploads/7dTT5D5oCDBg1Sw6HaZeoC/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/25gdn1ZfjeiYcCaDD8rGyk/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/f7RNmfj4cqZgvy96QE85yJ/pasted-image.jpg', 'https://cdn.magicpatterns.com/uploads/x2t4jkY7J58w5QwY4YWqW9/pasted-image.jpg', 'https://cdn.magicpatterns.com/uploads/hwgRBwWo4rUebUxVwzbfBm/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/3QnKHSF1XjcogvHFfcRpiE/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/vK1fLXoR8UUZtngLi3Agjk/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/ad3tF3YbBBTbQfv2gQDC2L/pasted-image.png'];
const liveCards = ['https://cdn.magicpatterns.com/uploads/12VX5HHC6M7kV9NsNDHwM9/image.png', 'https://cdn.magicpatterns.com/uploads/9mVDGGJSsGYsx7rGCwSotJ/image.png', 'https://cdn.magicpatterns.com/uploads/588VBS3dBL8FU4rwS3kF9p/image.png', 'https://cdn.magicpatterns.com/uploads/8Pb3n8LJWsKA5SpjUQN6B3/image.png', 'https://cdn.magicpatterns.com/uploads/ktMqaQnSFuw7Y6w5opYZdy/image.png'];
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % liveCards.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  return <section className="px-6 py-12 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-235">
      <h2 className="font-serif text-3xl md:text-5xl text-brand-navy mb-10" data-id="element-236">
        Conocé los testimonios 💘
      </h2>

      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mb-12 mx-auto" data-id="element-237">
        {chatImages.map((src, i) => <img key={i} src={src} alt={`Testimonio chat ${i + 1}`} className="w-full h-auto block drop-shadow-xl" data-id="element-238" />)}
      </div>

      {/* Live Testimonial Card */}
      <div className="w-full max-w-2xl relative aspect-[1.8/1] flex items-center justify-center" data-id="element-239">
        <AnimatePresence mode="wait" data-id="element-240">
          <motion.img key={currentIndex} src={liveCards[currentIndex]} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 1.05
        }} transition={{
          duration: 0.6,
          ease: 'easeInOut'
        }} className="w-full h-auto absolute drop-shadow-2xl" alt="Testimonio destacado" data-id="element-241" />
        </AnimatePresence>
      </div>

      <div className="flex gap-1.5 mt-6" data-id="element-242">
        {liveCards.map((_, i) => <div key={i} className={`h-1.5 rounded-full transition-all duration-500 ${i === currentIndex ? 'w-6 bg-brand-pinkDark' : 'w-1.5 bg-brand-navy/20'}`} data-id="element-243" />)}
      </div>
    </section>;
}